// Geometria da marca EntregueCerto: fonte única para o web, os apps e os arquivos gerados
// (scripts/marca/gerar.ts). Manual em docs/MARCA.md.
//
// Símbolo "cubo em movimento": um cubo isométrico de três faces arredondadas, separadas por um "Y" vazado, com três
// linhas de velocidade à esquerda. O vão entre as faces e entre as barras e o cubo é o mesmo (4 unidades).
//
// Cores (opção A, 22/10/2026): o logo leva o cubo dentro de um selo com o par da aba ativa (claro: selo tinta e cubo
// limão; escuro: selo limão e cubo tinta) e o nome neutro. Abaixo de 18 px e na impressão, o logo vai solto.

/** Título acessível dos SVGs. Igual a `marca.nome` (o teste garante); sem import para o gerador rodar no Node. */
const TITULO = 'EntregueCerto';

export const SIMBOLO = {
  /** Caixa do desenho completo (cubo + barras). */
  viewBox: '27.29 18.87 128.82 79.03',
  largura: 128.82,
  altura: 79.03,
  /** Faces (topo, esquerda, direita): preencher E contornar com `raio * 2`, junção redonda (cantos arredondados). */
  faces: [
    'M120.00 22.47 L146.91 38.00 L120.00 53.53 L93.09 38.00Z',
    'M87.49 47.70 L114.40 63.23 L114.40 94.30 L87.49 78.77Z',
    'M125.60 63.23 L152.51 47.70 L152.51 78.77 L125.60 94.30Z',
  ],
  raio: 3.6,
  /** Linhas de velocidade: traço com ponta redonda. */
  barras: 'M46.59 52.6H76.59M30.59 63.4H76.59M52.59 74.2H76.59',
  espessuraBarras: 6.6,
} as const;

/**
 * Logotipo "entreguecerto" em contorno (Manrope 700, espaçamento -0,025 em; fonte SIL OFL). Unidades: em = 1000;
 * `linhaDeBase` = base das letras a partir do topo; `alturaX` = altura do "x".
 */
export const LOGOTIPO = {
  largura: 6685.0,
  altura: 945.0,
  linhaDeBase: 690.0,
  alturaX: 540.0,
  d: 'M275.5 705Q193.5 705 131.5 669.5Q69.5 634 34.8 571Q0 508 0 426Q0 337.5 34 272.2Q68 207 128.5 171Q189 135 268.5 135Q352.5 135 411.2 174.2Q470 213.5 498.5 285Q527 356.5 520 453.5H400.5V409.5Q400 321.5 369.5 281Q339 240.5 273.5 240.5Q199.5 240.5 163.5 286.2Q127.5 332 127.5 420Q127.5 502 163.5 547Q199.5 592 268.5 592Q313 592 345.2 572.2Q377.5 552.5 395 515L514 551Q483 624 418.2 664.5Q353.5 705 275.5 705ZM89.5 453.5V362.5H461V453.5ZM965.5 690V430Q965.5 404.5 962 373.5Q958.5 342.5 945.8 313.8Q933 285 907.8 266.5Q882.5 248 839.5 248Q816.5 248 794 255.5Q771.5 263 753.2 281.2Q735 299.5 724 331.2Q713 363 713 412.5L641.5 382Q641.5 313 668.2 257Q695 201 747 167.8Q799 134.5 875 134.5Q935 134.5 974 154.5Q1013 174.5 1036 205.5Q1059 236.5 1070 271.5Q1081 306.5 1084.2 337.8Q1087.5 369 1087.5 388.5V690ZM591 690V150H698.5V317.5H713V690ZM1509 690Q1455.5 700 1404.2 698.8Q1353 697.5 1312.5 679.8Q1272 662 1251 623.5Q1232.5 588.5 1231.5 552Q1230.5 515.5 1230.5 469.5V0H1350.5V462.5Q1350.5 495 1351.2 519.5Q1352 544 1361.5 559.5Q1379.5 589.5 1419 593Q1458.5 596.5 1509 589ZM1132.5 244.5V150H1509V244.5ZM1600.5 690V150H1707V281.5L1694 264.5Q1704 237.5 1720.8 215.2Q1737.5 193 1761 178.5Q1781 165 1805.2 157.2Q1829.5 149.5 1855 147.8Q1880.5 146 1904.5 150V262.5Q1880.5 255.5 1849.2 258Q1818 260.5 1793 275.5Q1768 289 1752.2 310Q1736.5 331 1729 357.8Q1721.5 384.5 1721.5 415.5V690ZM2210 705Q2128 705 2066 669.5Q2004 634 1969.2 571Q1934.5 508 1934.5 426Q1934.5 337.5 1968.5 272.2Q2002.5 207 2063 171Q2123.5 135 2203 135Q2287 135 2345.8 174.2Q2404.5 213.5 2433 285Q2461.5 356.5 2454.5 453.5H2335V409.5Q2334.5 321.5 2304 281Q2273.5 240.5 2208 240.5Q2134 240.5 2098 286.2Q2062 332 2062 420Q2062 502 2098 547Q2134 592 2203 592Q2247.5 592 2279.8 572.2Q2312 552.5 2329.5 515L2448.5 551Q2417.5 624 2352.8 664.5Q2288 705 2210 705ZM2024 453.5V362.5H2395.5V453.5ZM2768.5 945Q2723.5 945 2682.2 931Q2641 917 2608 890.8Q2575 864.5 2554 827.5L2665 772.5Q2680.5 802 2708.8 816.2Q2737 830.5 2769 830.5Q2806.5 830.5 2836 817.2Q2865.5 804 2881.8 778.2Q2898 752.5 2897 714V560.5H2912V150H3017.5V716Q3017.5 736.5 3015.8 755.2Q3014 774 3010 792Q2998 844.5 2964 878.2Q2930 912 2879.8 928.5Q2829.5 945 2768.5 945ZM2758 705Q2683.5 705 2628 667.5Q2572.5 630 2542 565.5Q2511.5 501 2511.5 420Q2511.5 338 2542.2 273.8Q2573 209.5 2629.5 172.2Q2686 135 2762.5 135Q2839.5 135 2891.8 172.2Q2944 209.5 2971 274Q2998 338.5 2998 420Q2998 500.5 2971 565.2Q2944 630 2890.5 667.5Q2837 705 2758 705ZM2776.5 597Q2825 597 2854.8 574.8Q2884.5 552.5 2898.2 512.5Q2912 472.5 2912 420Q2912 367 2898.2 327.2Q2884.5 287.5 2855.5 265.2Q2826.5 243 2780.5 243Q2732 243 2700.5 266.8Q2669 290.5 2654 330.8Q2639 371 2639 420Q2639 469.5 2653.8 509.8Q2668.5 550 2699 573.5Q2729.5 597 2776.5 597ZM3335 705.5Q3275 705.5 3236 685.5Q3197 665.5 3174 634.5Q3151 603.5 3140 568.5Q3129 533.5 3125.8 502.2Q3122.5 471 3122.5 451.5V150H3244.5V410Q3244.5 435 3248 466.2Q3251.5 497.5 3264.2 526.2Q3277 555 3302.2 573.5Q3327.5 592 3370.5 592Q3393.5 592 3416 584.5Q3438.5 577 3456.8 558.8Q3475 540.5 3486 508.5Q3497 476.5 3497 427.5L3568.5 458Q3568.5 527 3541.8 583Q3515 639 3463 672.2Q3411 705.5 3335 705.5ZM3511.5 690V522.5H3497V150H3618V690ZM3978.5 705Q3896.5 705 3834.5 669.5Q3772.5 634 3737.8 571Q3703 508 3703 426Q3703 337.5 3737 272.2Q3771 207 3831.5 171Q3892 135 3971.5 135Q4055.5 135 4114.2 174.2Q4173 213.5 4201.5 285Q4230 356.5 4223 453.5H4103.5V409.5Q4103 321.5 4072.5 281Q4042 240.5 3976.5 240.5Q3902.5 240.5 3866.5 286.2Q3830.5 332 3830.5 420Q3830.5 502 3866.5 547Q3902.5 592 3971.5 592Q4016 592 4048.2 572.2Q4080.5 552.5 4098 515L4217 551Q4186 624 4121.2 664.5Q4056.5 705 3978.5 705ZM3792.5 453.5V362.5H4164V453.5ZM4544.5 705Q4461 705 4402 667.8Q4343 630.5 4311.8 566Q4280.5 501.5 4280 420Q4280.5 337 4312.8 272.8Q4345 208.5 4404.5 171.8Q4464 135 4546 135Q4638 135 4701.8 181.2Q4765.5 227.5 4785 307.5L4665 340Q4651 296.5 4618.5 272.2Q4586 248 4544.5 248Q4497.5 248 4467 270.2Q4436.5 292.5 4422 331.5Q4407.5 370.5 4407.5 420Q4407.5 497 4442 544.5Q4476.5 592 4544.5 592Q4592.5 592 4620.2 570Q4648 548 4662 506.5L4785 534Q4760 616.5 4697.5 660.8Q4635 705 4544.5 705ZM5091 705Q5009 705 4947 669.5Q4885 634 4850.2 571Q4815.5 508 4815.5 426Q4815.5 337.5 4849.5 272.2Q4883.5 207 4944 171Q5004.5 135 5084 135Q5168 135 5226.8 174.2Q5285.5 213.5 5314 285Q5342.5 356.5 5335.5 453.5H5216V409.5Q5215.5 321.5 5185 281Q5154.5 240.5 5089 240.5Q5015 240.5 4979 286.2Q4943 332 4943 420Q4943 502 4979 547Q5015 592 5084 592Q5128.5 592 5160.8 572.2Q5193 552.5 5210.5 515L5329.5 551Q5298.5 624 5233.8 664.5Q5169 705 5091 705ZM4905 453.5V362.5H5276.5V453.5ZM5422.5 690V150H5529V281.5L5516 264.5Q5526 237.5 5542.8 215.2Q5559.5 193 5583 178.5Q5603 165 5627.2 157.2Q5651.5 149.5 5677 147.8Q5702.5 146 5726.5 150V262.5Q5702.5 255.5 5671.2 258Q5640 260.5 5615 275.5Q5590 289 5574.2 310Q5558.5 331 5551 357.8Q5543.5 384.5 5543.5 415.5V690ZM6113 690Q6059.5 700 6008.2 698.8Q5957 697.5 5916.5 679.8Q5876 662 5855 623.5Q5836.5 588.5 5835.5 552Q5834.5 515.5 5834.5 469.5V0H5954.5V462.5Q5954.5 495 5955.2 519.5Q5956 544 5965.5 559.5Q5983.5 589.5 6023 593Q6062.5 596.5 6113 589ZM5736.5 244.5V150H6113V244.5ZM6415.5 705Q6334.5 705 6274 668.5Q6213.5 632 6180.2 567.8Q6147 503.5 6147 420Q6147 335 6181 271Q6215 207 6275.5 171Q6336 135 6415.5 135Q6497 135 6557.5 171.5Q6618 208 6651.5 272.2Q6685 336.5 6685 420Q6685 504 6651.2 568.2Q6617.5 632.5 6557 668.8Q6496.5 705 6415.5 705ZM6415.5 592Q6487.5 592 6522.5 544Q6557.5 496 6557.5 420Q6557.5 341.5 6522 294.8Q6486.5 248 6415.5 248Q6367 248 6335.8 269.8Q6304.5 291.5 6289.5 330.2Q6274.5 369 6274.5 420Q6274.5 498.5 6310.2 545.2Q6346 592 6415.5 592Z',
} as const;

type Variante = typeof SIMBOLO;

const FOLGA = 0.12 * LOGOTIPO.altura;

/**
 * Assinatura horizontal (cubo à esquerda): altura do símbolo = 1,55 x a linha de base, centrado na altura do "x";
 * respiro = 0,48 x a altura do "x". Unidades do logotipo.
 */
export const ASSINATURA = (() => {
  const escala = (LOGOTIPO.linhaDeBase * 1.55) / SIMBOLO.altura;
  const altSimbolo = SIMBOLO.altura * escala;
  const larguraSimbolo = SIMBOLO.largura * escala;
  const topoSimbolo = LOGOTIPO.linhaDeBase - LOGOTIPO.alturaX / 2 - altSimbolo / 2;
  const y0 = Math.min(topoSimbolo, 0);
  const y1 = Math.max(topoSimbolo + altSimbolo, LOGOTIPO.altura);
  const respiro = 0.48 * LOGOTIPO.alturaX;
  return {
    largura: Math.round(FOLGA + larguraSimbolo + respiro + LOGOTIPO.largura + FOLGA),
    altura: Math.round(y1 - y0 + 2 * FOLGA),
    simbolo: { x: FOLGA, y: FOLGA + topoSimbolo - y0, escala },
    logotipo: { x: FOLGA + larguraSimbolo + respiro, y: FOLGA - y0 },
  };
})();

/** Assinatura vertical (cubo em cima, como na arte original): símbolo com 70% da largura do nome. */
export const ASSINATURA_VERTICAL = (() => {
  const escala = (0.7 * LOGOTIPO.largura) / SIMBOLO.largura;
  const altSimbolo = SIMBOLO.altura * escala;
  const respiro = 0.62 * LOGOTIPO.alturaX;
  return {
    largura: Math.round(LOGOTIPO.largura + 2 * FOLGA),
    altura: Math.round(altSimbolo + respiro + LOGOTIPO.altura + 2 * FOLGA),
    simbolo: { x: FOLGA + (LOGOTIPO.largura - SIMBOLO.largura * escala) / 2, y: FOLGA, escala },
    logotipo: { x: FOLGA, y: FOLGA + altSimbolo + respiro },
  };
})();

/** Selo (opção A): raio e margem do símbolo em fração do lado. O cubo vai com as linhas em qualquer tamanho. */
export const SELO = { raio: 0.225, margem: 0.16 } as const;

/**
 * Assinatura horizontal com selo: o nome (caixa inteira do logotipo) tem 54% do lado do selo, centrado na altura, com
 * vão de 28% do lado. Unidades do logotipo; o selo começa na origem e encosta na borda (é ele que dá o contorno).
 */
export const ASSINATURA_COM_SELO = (() => {
  const lado = LOGOTIPO.altura / 0.54;
  return {
    largura: Math.ceil(1.28 * lado + LOGOTIPO.largura),
    altura: Math.ceil(lado),
    selo: { x: 0, y: 0, lado },
    logotipo: { x: 1.28 * lado, y: (lado - LOGOTIPO.altura) / 2 },
  };
})();

/** Assinatura vertical com selo: selo centrado em cima com 34% da largura do nome; respiro de 18% do lado. */
export const ASSINATURA_VERTICAL_COM_SELO = (() => {
  const lado = 0.34 * LOGOTIPO.largura;
  return {
    largura: Math.ceil(LOGOTIPO.largura),
    altura: Math.ceil(1.18 * lado + LOGOTIPO.altura),
    selo: { x: (LOGOTIPO.largura - lado) / 2, y: 0, lado },
    logotipo: { x: 0, y: 1.18 * lado },
  };
})();

// Valores literais (sem import) para o gerador rodar no Node; o teste garante que batem com ./rua.ts.
const limao = '#D4FF3A';
const tinta = '#0B0B0E';
const branco = '#FFFFFF';
/** Nome sobre fundo escuro: o texto do tema escuro. */
const nomeSobreEscuro = '#F5F5F7';

export const CORES_DA_MARCA = {
  limao,
  tinta,
  branco,
  preto: '#000000',
  nomeSobreEscuro,
  /** Assinatura e splash por tema: selo com o par da aba ativa, nome neutro, sobre o fundo do app. */
  claro: { fundo: branco, selo: tinta, simbolo: limao, nome: tinta },
  escuro: { fundo: tinta, selo: limao, simbolo: tinta, nome: nomeSobreEscuro },
  /** Ícones (o do dono também é o favicon do web): um o inverso do outro, para não confundir no celular. */
  icones: {
    dono: { fundo: limao, cor: tinta },
    entregador: { fundo: tinta, cor: limao },
  },
} as const;

/** Peças do símbolo (sem `<svg>` nem posição), no sistema do viewBox da variante. */
function pecasDoSimbolo(v: Variante, cor: string): string {
  const barras = v.barras
    ? `<path d="${v.barras}" fill="none" stroke="${cor}" stroke-width="${v.espessuraBarras}" stroke-linecap="round"/>`
    : '';
  const faces = v.faces
    .map(
      (d) =>
        `<path d="${d}" fill="${cor}" stroke="${cor}" stroke-width="${v.raio * 2}" stroke-linejoin="round"/>`,
    )
    .join('');
  return barras + faces;
}

/** `transform` que leva o desenho de `v` (no sistema do seu viewBox) para a posição `p` de uma assinatura. */
export function transformDoSimbolo(
  v: Variante,
  p: { x: number; y: number; escala: number },
): string {
  const [x = 0, y = 0] = v.viewBox.split(' ').map(Number);
  return `translate(${p.x} ${p.y}) scale(${p.escala}) translate(${-x} ${-y})`;
}

/**
 * Compensação óptica (em fração do lado) quando o símbolo vai centrado num quadrado: as linhas à esquerda são leves e o
 * cubo pesa à direita; puxar um pouco para a esquerda faz o conjunto parecer no centro.
 */
const AJUSTE_OPTICO_X = -0.012;

/** Posição do símbolo centrado num quadrado de lado `lado` que começa em (`x`, `y`), com `margem` em fração do lado. */
function noQuadrado(
  v: Variante,
  q: { x: number; y: number; lado: number },
  margem: number,
  ajuste: boolean,
) {
  const util = q.lado * (1 - 2 * margem);
  const escala = Math.min(util / v.largura, util / v.altura);
  const optico = ajuste ? AJUSTE_OPTICO_X * q.lado : 0;
  return {
    x: q.x + (q.lado - v.largura * escala) / 2 + optico,
    y: q.y + (q.lado - v.altura * escala) / 2,
    escala,
  };
}

/**
 * O que vai dentro do selo de uma assinatura: o raio do selo e o `transform` do símbolo, em unidades da assinatura.
 * Mesma conta no web, nos apps e nos arquivos gerados.
 */
export function simboloNoSelo(selo: { x: number; y: number; lado: number }) {
  return {
    raio: SELO.raio * selo.lado,
    transform: transformDoSimbolo(SIMBOLO, noQuadrado(SIMBOLO, selo, SELO.margem, true)),
  };
}

/** SVG do símbolo (string), para gerar arquivos. `fundo` desenha o quadrado do ícone. */
export function svgSimbolo(opcoes: {
  cor: string;
  tamanho?: number;
  fundo?: string;
  /** Margem em volta do símbolo, em fração do lado (ícones: 0,12; adaptativo do Android: 0,24). */
  margem?: number;
  raio?: number;
}): string {
  const v: Variante = SIMBOLO;
  const lado = opcoes.tamanho ?? 48;
  const margem = opcoes.margem ?? 0;
  const p = noQuadrado(v, { x: 0, y: 0, lado }, margem, Boolean(opcoes.fundo || margem));
  const fundo = opcoes.fundo
    ? `<rect width="${lado}" height="${lado}" rx="${opcoes.raio ?? 0}" fill="${opcoes.fundo}"/>`
    : '';
  return (
    `<svg xmlns="http://www.w3.org/2000/svg" role="img" width="${lado}" height="${lado}" viewBox="0 0 ${lado} ${lado}">` +
    `<title>${TITULO}</title>` +
    fundo +
    `<g transform="${transformDoSimbolo(v, p)}">${pecasDoSimbolo(v, opcoes.cor)}</g>` +
    '</svg>'
  );
}

/**
 * SVG da assinatura (string). `corNome` pinta o "entreguecerto"; `corSimbolo`, o cubo. Com `corSelo`, o cubo vai
 * dentro do selo dessa cor (opção A); sem ela, o logo vai solto (impressão, abaixo de 18 px). `altura` em px.
 */
export function svgAssinatura(opcoes: {
  corSimbolo: string;
  corNome: string;
  corSelo?: string;
  altura?: number;
  vertical?: boolean;
  /** Fundo opaco atrás de tudo (logo do e-mail, para não sumir em cliente de e-mail no escuro). */
  fundo?: string;
}): string {
  let a: { largura: number; altura: number; logotipo: { x: number; y: number } };
  let simbolo: string;
  if (opcoes.corSelo) {
    const s = opcoes.vertical ? ASSINATURA_VERTICAL_COM_SELO : ASSINATURA_COM_SELO;
    const n = simboloNoSelo(s.selo);
    a = s;
    simbolo =
      `<rect x="${s.selo.x}" y="${s.selo.y}" width="${s.selo.lado}" height="${s.selo.lado}" rx="${n.raio}" fill="${opcoes.corSelo}"/>` +
      `<g transform="${n.transform}">${pecasDoSimbolo(SIMBOLO, opcoes.corSimbolo)}</g>`;
  } else {
    const s = opcoes.vertical ? ASSINATURA_VERTICAL : ASSINATURA;
    a = s;
    simbolo = `<g transform="${transformDoSimbolo(SIMBOLO, s.simbolo)}">${pecasDoSimbolo(SIMBOLO, opcoes.corSimbolo)}</g>`;
  }
  const altura = opcoes.altura ?? a.altura;
  const largura = Math.round((a.largura * altura) / a.altura);
  const fundo = opcoes.fundo
    ? `<rect width="${a.largura}" height="${a.altura}" fill="${opcoes.fundo}"/>`
    : '';
  return (
    `<svg xmlns="http://www.w3.org/2000/svg" role="img" width="${largura}" height="${altura}" viewBox="0 0 ${a.largura} ${a.altura}">` +
    `<title>${TITULO}</title>` +
    fundo +
    simbolo +
    `<path transform="translate(${a.logotipo.x} ${a.logotipo.y})" d="${LOGOTIPO.d}" fill="${opcoes.corNome}"/>` +
    '</svg>'
  );
}
